import { Avatar } from './Person';

export interface FeedEntry {
  id: string;
  /** Звонок — запись менеджера о разговоре (БЛ M3 3.8) */
  kind: 'system' | 'comment' | 'call';
  text: string;
  author: { fullName: string } | null;
  createdAt: string;
  /** Откуда событие, если лента собрана из нескольких карточек: «сделка Ростов-на-Дону 30–31.01» */
  context?: string | null;
}

const MONTHS = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
];

const dayKey = (d: Date) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;

/** «Сегодня» или «19 октября 2026» — разделитель дат ленты `.dsep`. */
export function dayWord(d: Date, now = new Date()): string {
  if (dayKey(d) === dayKey(now)) return 'Сегодня';
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

const hhmm = (d: Date) => `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;

const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w.charAt(0))
    .join('')
    .toUpperCase();

/**
 * Лента `.feed` (кит): записи по дням с разделителями, новые сверху.
 * Комментарий — с автором и заметкой `.fnote`, звонок — с автором
 * и текстом без заметки, системное — «Система». Контекст — приписка
 * `.fctx` в шапке записи: в карточке клиента «сделка …», в сделке «номер …».
 */
export function Feed({ items }: { items: FeedEntry[] }) {
  const days: { key: string; date: Date; items: FeedEntry[] }[] = [];
  for (const item of items) {
    const date = new Date(item.createdAt);
    const key = dayKey(date);
    const last = days[days.length - 1];
    if (last?.key === key) last.items.push(item);
    else days.push({ key, date, items: [item] });
  }
  return (
    <div className="feed fpad">
      {days.map((day) => (
        <div key={day.key}>
          <div className="dsep">
            <span>{dayWord(day.date)}</span>
            <i />
          </div>
          {day.items.map((e) => {
            const ctx = e.context ? <span className="fctx">· {e.context}</span> : null;
            return e.kind === 'system' ? (
              <div className="fi" key={e.id}>
                <div className="fh">
                  <span className="tp">Система</span>
                  <span>{hhmm(new Date(e.createdAt))}</span>
                  {ctx}
                </div>
                <div className="fsys">{e.text}</div>
              </div>
            ) : (
              <div className="fi" key={e.id}>
                <div className="fh">
                  <Avatar initials={initials(e.author?.fullName ?? '?')} size={22} />
                  <span className="who">{e.author?.fullName}</span>
                  <span className="tp">
                    {e.kind === 'call' ? 'звонок' : 'комментарий'} · {hhmm(new Date(e.createdAt))}
                  </span>
                  {ctx}
                </div>
                {e.kind === 'comment' ? <div className="fnote">{e.text}</div> : <div className="fsys">{e.text}</div>}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
